import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cms-news-list',
  templateUrl: './news-list.component.html',
})
export class NewsListComponent implements OnInit {

    title: string = 'Notícias';
    addButtonText: string = 'Adicionar Notícia';

    constructor() { }

    ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/noticias/news-list/news-list.component.ts